import React from 'react';
import axios from 'axios';
import Boton from './Boton'
import './css/Login.css';

class Cambiarpass extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      oldPass:"",
      newPass:"",
      repPass:""
    }
  }

  cambiarPass(){
    const {oldPass, newPass, repPass} = this.state;
    if (oldPass !== "" && newPass !== "" && repPass !== ""){
      if (newPass === repPass){
        const consulta = {
          oldPass,
          newPass
        };
        //CAMBIAR A API DEL SISTEMA
        const url = localStorage.getItem('apiUrl') + '/users/cambiarpass';
        const config = {headers:{authorization:sessionStorage.getItem('token')}}
        axios.post(url, consulta, config)
        .then((res) =>{
          if (res.data.status === "ok"){
            alert("Contraseña actualizada");
            this.props.history.push('/');
          } else {
            alert(res.data.error);
          }
        })
        .catch((err) => {
          alert("Ocurrio un error");
          console.log(err);
        })
      } else {
        alert("Contraseñas no coinciden!");
      }
    } else {
      alert("Complete todos los campos");
    }
  }

  render(){
    const {oldPass, newPass, repPass} = this.state;
    return(
      <div className="Todo Login">
        <div className="Container">
          <h2 style={{color:'white'}}>Cambiar Contraseña</h2>
          <input
            type="password" style={{flex:1}}
            onChange={(e)=>this.setState({oldPass:e.target.value})}
            value={oldPass}
            placeholder="Contraseña actual"
          />
          <input
            type="password" style={{flex:1}}
            onChange={(e)=>this.setState({newPass:e.target.value})}
            value={newPass}
            placeholder="Nueva Contraseña"
          />
          <input
            type="password" style={{flex:1}}
            onChange={(e)=>this.setState({repPass:e.target.value})}
            value={repPass}
            placeholder="Repita Contraseña"
          />
          <Boton
            backgroundColor="#00a5e5"
            titulo="Ingresar"
            onClick={() => this.cambiarPass()}
          />
        </div>
      </div>
    );
  }
}

export default Cambiarpass;
